import { ElMessage } from 'element-plus'
import { nextTick } from 'vue'
// 创建一个遮罩层
const createOverlay = (width, height, dom) => {
  // 判断页面中是否已经有该元素，有就直接返回
  if (document.getElementById(dom.id + '_overlay')) return
  dom.style.position = 'relative'
  // 创建遮罩层元素
  const overlay = document.createElement('div')
  overlay.id = dom.id + '_overlay'
  // 设置遮罩层样式
  overlay.style.position = 'absolute'
  overlay.style.top = '0'
  overlay.style.left = '0'
  overlay.style.width = width
  overlay.style.height = height
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.3)' // 半透明黑色
  overlay.style.zIndex = '999' // 确保遮罩层位于其他内容上面
  overlay.style.cursor = 'not-allowed' // 禁止点击的样式
  // 添加点击事件监听器，阻止事件传播
  overlay.addEventListener('click', function (event) {
    event.stopPropagation()
    ElMessage.error('当前服务版本不支持该功能')
  })
  // 将遮罩层附加到目标DOM节点上
  dom.appendChild(overlay)
}

export const packageMask = (app, myStore) => {
  app.directive('packageMask', {
    // 组件数据更新时调用
    beforeUpdate(el, binding) {
      const currentPackage = myStore.getters.getReportPackage
      setTimeout(() => {
        // 只有基础版套餐才会被禁用
        currentPackage === 1 && createOverlay(el.offsetWidth + 'px', el.offsetHeight + 'px', el)
      }, 200)
    },
  })
}
